import { DailyJobsComponent } from "./dailyJobs";
import { LoadIntercontratsComponent } from "./LoadIntercontrats";
import { MonitoringComponent } from "./Monitoring";
import { CallHistoryComponent  } from "./CallHistory"


export const MonitoringRoutes = [{
    path: '/monitoring',
    element: <MonitoringComponent />,
    role: 'Pocahontas_Monitoring'
},
{
    path: '/dailyjobs',
    element: <DailyJobsComponent />,
    role: 'Pocahontas_DailyJob'
    },
    {
        path: '/loadintercontrats',
        element: <LoadIntercontratsComponent/>,
        role: 'Pocahontas_DailyJob'
    },
    {
        path: '/callHistory',
        element: <CallHistoryComponent />,
        role: 'Pocahontas_Monitoring'
    }
]